import Icon from "../../lib/icons";
import { useLang } from "../../i18n";
import { FOCUS_AREAS } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";

export default function Focus() {
  const { pick } = useLang();
  return (
    <section data-testid="focus-section" className="py-24 bg-ngo-mint/60 relative grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <SectionHeading
          overline={pick({ hi: "कार्य क्षेत्र", en: "Focus Areas" })}
          title={pick({ hi: "हमारे प्रमुख कार्य क्षेत्र", en: "Our Key Focus Areas" })}
          description={pick({
            hi: "आठ क्षेत्र, एक ही संकल्प — हर जरूरतमंद तक अवसर और सहायता पहुंचाना।",
            en: "Eight areas, one resolve — reaching every person in need with opportunity and support.",
          })}
          testid="focus-heading"
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FOCUS_AREAS.map((area, i) => (
            <Reveal key={area.icon + i} i={i % 4}>
              <div
                data-testid={`focus-card-${i}`}
                className="group relative h-full bg-white rounded-2xl border border-ngo-deep/10 p-7 overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_18px_44px_rgba(23,107,58,0.14)] transition-[box-shadow,transform] duration-300"
              >
                <span className="absolute top-4 right-5 font-heading font-black text-4xl text-ngo-deep/10 group-hover:text-ngo-gold/40 transition-colors duration-300" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="w-12 h-12 rounded-xl bg-ngo-mint flex items-center justify-center text-ngo-deep group-hover:bg-ngo-gold group-hover:text-ngo-forest transition-colors duration-300">
                  <Icon name={area.icon} size={22} />
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-ngo-ink">{pick({ hi: area.hi.title, en: area.en.title })}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ngo-ink/65">{pick({ hi: area.hi.desc, en: area.en.desc })}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
